import { GET_SIORG_ORGANS_LIST } from '../../constants/ActionTypes';

/**
 * Get the organs list from SIORG.
 * @function getSiorgOrgansList
 * @returns {Object} Get organs list
 */
export function getSiorgOrgansList() {
  return {
    type: GET_SIORG_ORGANS_LIST,
    request: {
      op: 'get',
      path: '/@siorg',
    },
  };
}
